import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.textA} textA`}>
            <div className="kit-ms1">{t('presale.product.kitL_ms1')}</div>
        </div>
    );
}
